export default __webpack_public_path__ + "static/media/baba-studio-reactjs.d1b997a1.jpg";